import { Alert, Box, Button } from "@mui/material";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

import { DiscardButton, SaveButton } from "~/components/Buttons";
import useRecordStepperView from "~/components/recordStepper/useRecordStepperView";

const RecordStepperPrompt = () => {
	const { t } = useTranslation("common");
	const { stepper, view } = useRecordStepperView();
	const stayRef = useRef<HTMLButtonElement>(null);
	const isOpen = view.prompt !== null;

	useEffect(() => {
		if (isOpen) stayRef.current?.focus();
	}, [isOpen]);

	if (!stepper || !view.prompt) return null;
	const { canSave, isSaving } = view.prompt;

	return (
		<Alert severity="warning" sx={{ "& .MuiAlert-message": { flex: 1, minWidth: 0 }, borderRadius: 0 }}>
			{t("recordStepper.prompt.message")}
			<Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, justifyContent: "flex-end", mt: 1 }}>
				<Button
					color="inherit"
					disabled={isSaving}
					onClick={() => stepper.resolvePrompt("stay")}
					ref={stayRef}
					size="small"
					variant="text"
				>
					{t("recordStepper.prompt.stay")}
				</Button>
				<DiscardButton disabled={isSaving} onClick={() => stepper.resolvePrompt("discard")} size="small" />
				{canSave && (
					<SaveButton
						loading={isSaving}
						onClick={() => stepper.resolvePrompt("save")}
						size="small"
						sx={{ width: "auto" }}
					>
						{t("recordStepper.prompt.saveAndContinue")}
					</SaveButton>
				)}
			</Box>
		</Alert>
	);
};

export default RecordStepperPrompt;
